<section [class.gap-8]="buttonName === 'compare'">
  <app-cts-gantry-startup-event-filter
    id="cts-gantry-startup-event-filter"
    [events]="events"
    [selectedEvent]="selectedEvent"
    (selectedEventChange)="onSelectedEventChange($event)"
  >
  </app-cts-gantry-startup-event-filter>

  <sh-text color="secondary">{{ handleSoftwareVersion() }}</sh-text>
</section>

<sh-button
  id="cts-gantry-startup-action-button"
  (click)="onButtonClick()"
  (keydown.enter)="onButtonClick()"
  color="tertiary"
  label="{{ 'cts.gantry.' + buttonName | translate }}"
></sh-button>
